import React from "react";
import {
  DateInput,
  FileField,
  FileInput,
  FormDataConsumer,
  FormTab,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput,
  TabbedForm,
  TextInput,
} from "react-admin";
import { AddressInput } from "../components/AddressInput";
import { CustomToolbar } from "../components/CustomToolbar";
import { FormProps } from "../shared/types";
import { initField, initInput } from "../shared/utils";
import { Grid, Typography } from "@material-ui/core";
import { CustomPhotoField } from "../components/CustomPhotoField";
import {ReferenceArrayInputSubject} from "../components/reference-inputs/ReferenceArrayInputSubject";
import { validateIban } from "../shared/iban";

export const EmployeeForm = (props: FormProps) => {
  const ibanInput = initInput("iban", props.fieldOptions, props.canEdit);

  return (
    <TabbedForm
      toolbar={
        <CustomToolbar canEdit={props.canEdit} canDelete={props.canDelete} />
      }
      {...props}
    >
      <FormTab label="Info generali">
        <Grid container style={{ width: "100%" }} spacing={2} >
          <Grid item xs={8}>
            <TextInput {...initInput("name", props.fieldOptions, props.canEdit)} />
            <TextInput
              {...initInput("surname", props.fieldOptions, props.canEdit)}
            />
            <SelectInput
              {...initInput("gender", props.fieldOptions, props.canEdit, "array")}
              choices={props.fieldOptions.gender.choices}
            />
            <DateInput
              {...initInput("date_of_birth", props.fieldOptions, props.canEdit)}
            />
            <TextInput
              {...initInput("place_of_birth", props.fieldOptions, props.canEdit)}
            />
            <TextInput
              {...initInput("fiscal_code", props.fieldOptions, props.canEdit)}
            />
            <TextInput
              {...initInput("identity_card", props.fieldOptions, props.canEdit)}
            />
            <ReferenceArrayInput
              {...initInput("departments", props.fieldOptions, props.canEdit)}
              reference="autocomplete/department"
            >
              <SelectArrayInput optionText="label" />
            </ReferenceArrayInput>
              <ReferenceArrayInputSubject source={"carriers"} label="Vettori" fullWidth/>
            <ReferenceArrayInput
              {...initInput("sites", props.fieldOptions, props.canEdit)}
              reference="autocomplete/site"
              label="Sedi"
            >
              <SelectArrayInput optionText="label" />
            </ReferenceArrayInput>
            <SelectInput
              {...initInput("status", props.fieldOptions, props.canEdit, "array")}
              choices={props.fieldOptions.status.choices}
            />
              <TextInput
                  {...ibanInput}
                  validate={[
                    ...(ibanInput.validate || []),
                    validateIban,
                  ]}
              />
          </Grid>
          <Grid container item xs={4}>
            <Grid item xs={12}>
              <CustomPhotoField
                {...initField("file_info", props.fieldOptions)}
                title="name"
                src="url"
              />
            </Grid>
            <Grid item xs={12}>
              <FileInput
                {...initInput("file", props.fieldOptions, props.canEdit)}
              >
                <FileField source="src" title="title" />
              </FileInput>
            </Grid>
          </Grid>
        </Grid>
      </FormTab>
      <FormTab label="Residenza">
        <AddressInput options={props.fieldOptions} canEdit={props.canEdit} />
      </FormTab>
      <FormTab label="Contatti">
        <TextInput
          {...initInput("identity_card", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("phone_number", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("phone_number_2", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("phone_number_notes", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          type="email"
          {...initInput("email", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          type="email"
          placeholder="Email personale"
          {...initInput("personal_email", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          type="email"
          {...initInput("pec", props.fieldOptions, props.canEdit)}
        />
      </FormTab>

      <FormTab label="Dispositivo">

        <TextInput
          {...initInput("device_name", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("device_serial", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("device_imei1", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("device_imei2", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("device_unlock", props.fieldOptions, props.canEdit)}
        />
        <DateInput
          {...initInput("device_date", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          type="email"
          {...initInput("device_email", props.fieldOptions, props.canEdit)}
        />

      </FormTab>
      <FormTab label="SIM">
        <TextInput
          {...initInput("work_phone_number", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("device_iccd", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("device_pin", props.fieldOptions, props.canEdit)}
        />
        <TextInput
          {...initInput("device_puk", props.fieldOptions, props.canEdit)}
        />
      </FormTab>
      <FormDataConsumer>
        {({ formData, scopedFormData, getSource, ...rest }) =>
          formData.departments && formData.departments.includes("Autista") && (
            <FormTab {...rest} label="Info autista">
              <SelectInput
                choices={props.fieldOptions.license.choices}
                {...initInput(
                  "license",
                  props.fieldOptions,
                  props.canEdit,
                  "array"
                )}
              />
              <TextInput
                {...initInput("device", props.fieldOptions, props.canEdit)}
              />
              <TextInput
                {...initInput(
                  "fuel_card_number",
                  props.fieldOptions,
                  props.canEdit
                )}
              />
            </FormTab>
          )
        }
      </FormDataConsumer>
    </TabbedForm>
  );
};
